var _rect, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThere2BBackgroundElementsFullVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 4000,
    height: 1568,
    viewBox: "0 0 4000 1568",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 4000,
    height: 1568,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,210) scale(.9375)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".o{fill:none;stroke:#E89E45;stroke-opacity:.32;stroke-width:2.2}.w{fill:none;stroke:#E89E45;stroke-opacity:.16;stroke-width:2}.ws{fill:none;stroke:#E89E45;stroke-opacity:.11;stroke-width:1.8}.dot{fill:#E89E45;fill-opacity:.45}.wdot{fill:#E89E45;fill-opacity:.28}")), /*#__PURE__*/React.createElement("rect", {
    className: "ws",
    x: -120,
    y: 120,
    width: 550,
    height: 500
  }), /*#__PURE__*/React.createElement("rect", {
    className: "o",
    x: 80,
    y: 250,
    width: 430,
    height: 550
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ws",
    x: 530,
    y: 185,
    width: 170,
    height: 170
  }), /*#__PURE__*/React.createElement("rect", {
    className: "o",
    x: 670,
    y: 310,
    width: 260,
    height: 280
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ws",
    x: 270,
    y: 740,
    width: 420,
    height: 360
  }), /*#__PURE__*/React.createElement("rect", {
    className: "o",
    x: 840,
    y: 680,
    width: 340,
    height: 360
  }), /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "M100 160 V60 H250"
  }), /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "M1160 120 H1280 V260"
  }), /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "M140 1080 V955 H285"
  }), /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "M1320 990 V1120 H1180"
  }), /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "M430 445 H540 V560 H640"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "o",
    cx: 660,
    cy: 710,
    r: 58
  }), /*#__PURE__*/React.createElement("circle", {
    className: "o",
    cx: 660,
    cy: 710,
    r: 95
  }), /*#__PURE__*/React.createElement("circle", {
    className: "ws",
    cx: 660,
    cy: 710,
    r: 150
  }), /*#__PURE__*/React.createElement("circle", {
    className: "wdot",
    cx: 660,
    cy: 710,
    r: 12
  }), /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "M-220 650 C160 410 520 420 960 600"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M90 520 C330 100 850 40 1140 270"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ws",
    d: "M320 900 C600 720 850 690 1200 780"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dot",
    cx: 190,
    cy: 250,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "o",
    cx: 190,
    cy: 250,
    r: 13
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dot",
    cx: 445,
    cy: 465,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "o",
    cx: 445,
    cy: 465,
    r: 13
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dot",
    cx: 820,
    cy: 350,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "o",
    cx: 820,
    cy: 350,
    r: 13
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dot",
    cx: 1045,
    cy: 615,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "o",
    cx: 1045,
    cy: 615,
    r: 13
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dot",
    cx: 1200,
    cy: 880,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "o",
    cx: 1200,
    cy: 880,
    r: 13
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dot",
    cx: 330,
    cy: 875,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "o",
    cx: 330,
    cy: 875,
    r: 13
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dot",
    cx: 720,
    cy: 1010,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "o",
    cx: 720,
    cy: 1010,
    r: 13
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dot",
    cx: 970,
    cy: 225,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "o",
    cx: 970,
    cy: 225,
    r: 13
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(2500,150) scale(.9375)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".o{fill:none;stroke:#E89E45;stroke-opacity:.32;stroke-width:2.2}.w{fill:none;stroke:#E89E45;stroke-opacity:.16;stroke-width:2}.ws{fill:none;stroke:#E89E45;stroke-opacity:.11;stroke-width:1.8}.dot{fill:#E89E45;fill-opacity:.45}.wdot{fill:#E89E45;fill-opacity:.28}")), /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "M-90 620 C310 60 1120 20 1550 360"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M90 700 C430 180 1110 140 1450 410"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ws",
    d: "M265 735 C590 300 1060 300 1325 560"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M450 805 C690 470 1030 410 1190 610"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "o",
    cx: 960,
    cy: 395,
    r: 52
  }), /*#__PURE__*/React.createElement("circle", {
    className: "ws",
    cx: 960,
    cy: 395,
    r: 100
  }), /*#__PURE__*/React.createElement("circle", {
    className: "o",
    cx: 960,
    cy: 395,
    r: 155
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dot",
    cx: 960,
    cy: 395,
    r: 9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ws",
    x: 1020,
    y: 520,
    width: 520,
    height: 390
  }), /*#__PURE__*/React.createElement("rect", {
    className: "o",
    x: 735,
    y: 500,
    width: 420,
    height: 335
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ws",
    x: 560,
    y: 300,
    width: 315,
    height: 260
  }), /*#__PURE__*/React.createElement("rect", {
    className: "o",
    x: 1125,
    y: 690,
    width: 265,
    height: 200
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ws",
    x: 350,
    y: 790,
    width: 435,
    height: 245
  }), /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "M240 210 V120 H485 V195"
  }), /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "M1225 110 H1380 V225 H1500"
  }), /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "M100 1000 H245 V1100"
  }), /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "M1320 1045 H1470 V905"
  }), /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "M630 655 H840 V760 H1030"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dot",
    cx: 280,
    cy: 450,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "o",
    cx: 280,
    cy: 450,
    r: 13
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dot",
    cx: 530,
    cy: 300,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "o",
    cx: 530,
    cy: 300,
    r: 13
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dot",
    cx: 760,
    cy: 600,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "o",
    cx: 760,
    cy: 600,
    r: 13
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dot",
    cx: 925,
    cy: 395,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "o",
    cx: 925,
    cy: 395,
    r: 13
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dot",
    cx: 1110,
    cy: 730,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "o",
    cx: 1110,
    cy: 730,
    r: 13
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dot",
    cx: 1350,
    cy: 645,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "o",
    cx: 1350,
    cy: 645,
    r: 13
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dot",
    cx: 475,
    cy: 920,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "o",
    cx: 475,
    cy: 920,
    r: 13
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dot",
    cx: 1150,
    cy: 190,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "o",
    cx: 1150,
    cy: 190,
    r: 13
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThere2BBackgroundElementsFullVector);
export default __webpack_public_path__ + "static/media/there2b_background_elements_full_vector.0c52ef80ec35c31a52471f438271c8ee.svg";
export { ForwardRef as ReactComponent };